import type { ListeningContext } from './useMoteTrackMutate'

export function convertToListeningContext(
  isLanding: boolean,
  isEmbed: boolean
): ListeningContext {
  switch (true) {
    case isLanding:
      return 'landing-page'
    case isEmbed:
      return 'embed'
    default:
      return 'extension'
  }
}
